export class CourseModel {
  constructor (data) {
    this._id = (data._id || null)
    this.title = (data.title || null)
    this.slug = (data.slug || null)
    this.workload = (data.workload || null)
    this.description = (data.description || null)
    this.price = (data.price || 0)
    this.priceWithTax = (data.priceWithTax || 0)
    this.isPublic = (data.isPublic || false)
    this.coverUrl = (data.coverUrl || null)
    this.videoIntro = {
      vimeoId: (data.videoIntro && data.videoIntro.vimeoId || null),
      vimeoStatus: (data.videoIntro && data.videoIntro.vimeoStatus || null),
    }
    this.modules = (data.modules || [])
    this.contents = (data.contents || [])
    this.user = (data.user || null)
  }
}
